import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

// Constants
import GoalsConstants from 'Shared/constants/Goals.constants';
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';

const initialState = Map({
  [GoalsConstants.State.GOALS_BY_GOAL_SLUG]: OrderedMap(),
});

export const GoalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GoalsConstants.Actions.MARK_GOAL_COMPLETE_SUCCESS:
    case GoalsConstants.Actions.MARK_GOAL_INCOMPLETE_SUCCESS:
    case GoalsConstants.Actions.CHANGE_STATUS_SUCCESS:
    case GoalsConstants.Actions.CREATE_GOAL_SUCCESS:
    case GoalsConstants.Actions.FETCH_GOALS_SUCCESS:
    case GoalsConstants.Actions.FETCH_SINGLE_GOAL_SUCCESS:
    case GoalsConstants.Actions.UPDATE_GOAL_SUCCESS:
    case UserSuggestionsConstants.Actions.FETCH_USER_SUGGESTIONS_SUCCESS:
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn([GoalsConstants.State.GOALS_BY_GOAL_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.goal).map(item => [item.attributes.slug, Map(fromJS(item.attributes))])
          )
        )
      );
    case GoalsConstants.Actions.MOVE_GOAL_SUCCESS:
      return state.updateIn([GoalsConstants.State.GOALS_BY_GOAL_SLUG], (existing = OrderedMap()) =>
        existing.mergeDeep(
          OrderedMap(
            Object.values(action.payload.goal).map(item => [item.attributes.slug, Map(fromJS(item.attributes))])
          )
        )
      );
    case GoalsConstants.Actions.MOVE_GOAL_WITHOUT_REQUEST_SUCCESS:
      return state.updateIn([GoalsConstants.State.GOALS_BY_GOAL_SLUG], (existing = OrderedMap()) =>
        existing.merge(action.payload.map(item => [item.slug, Map(fromJS(item))]))
      );
    case GoalsConstants.Actions.DELETE_GOAL_SUCCESS:
      return state.deleteIn([GoalsConstants.State.GOALS_BY_GOAL_SLUG, action.payload]);
    default:
      return state;
  }
};
